<app-spinner [active]="loading"></app-spinner>
<div class="content-header" id="grad">
  <h1 class="header-title">User Management</h1>
</div>
<app-modal
  [active]="modal.active"
  [data]="modal.data"
  (confirmed)="modalConfirmed($event)"
  (denied)="modalDenied($event)"
>
</app-modal>
<div *ngIf="!updating" class="filter-container">
  <input
    aria-label="Filter by Name"
    *ngIf="searching"
    (keyup)="onKey($event)"
    type="text"
    placeholder="Filter by Name"
    [(ngModel)]="query"
  />
  <app-button
    [disabled]="
      usersWithIsMarsAdminChange.length +
      usersWithBaseChange.length +
        usersWithRoleChange.length +
        usersWithActiveChange.length +
        usersWithEmailChange.length + 
        usersWithEmailNotifyChange.length 
        > 0
        ? false
        : true
    "
    (clicked)="updateUsers()"
    text="Update"
  ></app-button>
</div>
<div class="user-table" *ngIf="!updating">
  <div class="headers row">
    <div class="header">
      <span>Name</span>
    </div>
    <div class="header">
      <span>Base</span>
    </div>
    <div class="header">
      <span>Email</span>
    </div>
    <div class="header">
      <span>MARS Admin</span>
    </div>
    <div class="header">
      <span>MARS Email Notification</span>
    </div>
    <div class="header">
      <span>User Role</span>
    </div>
    <div style="width: 50px" class="cell"></div>
  </div>
  <div class="rows">
    <div class="row" *ngFor="let user of users">
      <div class="cell">
        <span>{{ user.firstname + ' ' + user.lastname }}</span>
      </div>
      <div class="cell">
        <app-dropdown
          [choice]="user"
          [options]="bases"
          key="userBaseCode"
          label="Base"
          (selectedDropdownItem)="selectBase($event, user)"
        ></app-dropdown>
      </div>

      <div class="cell">
        <input 
          type="text"
          [(ngModel)]="user.email"
          (blur)="selectEmail(user)"
        />
      </div>

      <div class="cell">
        <input 
          type="checkbox"
          [(ngModel)]="user.isMarsAdmin"
          (change)="selectIsMarsAdmin(user)"
        />
      </div>

      <div class="cell">
        <input
          aria-label="Select User"
          type="checkbox"
          (click)="selectEmailNotification(user)"
          [(ngModel)]="user.emailNotification"
          onkeypress="selectEmailNotification(user)"
        />
      </div>

      <div class="cell">
        <app-dropdown
          [choice]="user"
          [options]="[
            { role: 'user', value: 'user' },
            { role: 'baseadmin', value: 'baseadmin' },
            { role: 'sysadmin', value: 'sysadmin' }
          ]"
          key="role"
          label="Role"
          (selectedDropdownItem)="selectRole($event, user)"
        ></app-dropdown>
      </div>
      <button (click)="confirmDelete(user)" class="cell trash">🗑</button>
    </div>
  </div>
</div>
<div class="updating" *ngIf="updating">
  <p class="update-text">{{ getUpdateText() }}</p>
  <div class="progress-bar">
    <div class="progress" [ngStyle]="{ width: percent + '%' }"></div>
  </div>
</div>